type RetrieveUserRoleResponse = {
  id: string
  name: string
  permissions: Array<string>
}

export type RetieveUserResponse = {
  id: string
  firstName: string
  lastName: string
  email: string
  role: RetrieveUserRoleResponse | null
}

export const retrieveUser = async (id: string) => {
  const { body } = await api.get<RetieveUserResponse>(
    `/users/${id}/`
  )
  return body
}
